import { render, staticRenderFns } from "./courseBalanceCosts.vue?vue&type=template&id=2c25d6e6&scoped=true&"
import script from "./courseBalanceCosts.vue?vue&type=script&lang=js&"
export * from "./courseBalanceCosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c25d6e6",
  null
  
)

export default component.exports